import { type NotificationType } from '@/redux/slices/notificationSlice'
import ItemWrapper from './ItemWrapper'

export default function SmtpAccountAuthFail({ notification }: { notification: NotificationType }) {
  return <ItemWrapper notification={notification}>SMTP 邮件服务器配置发生错误，请检查配置</ItemWrapper>
}
